module.exports = __webpack_public_path__ + "img/logo-plain.b6ff5d27.svg";